import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PsyTestingService } from '../../services/psy-testing.service';
import {
  generatePsyTest,
  generatePsyTestSuccess,
  generatePsyTestFailure,
  savePsyTestAnswersFailure,
  savePsyTestAnswersSuccess,
  savePsyTestAnswers,
  fetchPsyTestReportFailure,
  fetchPsyTestReportSuccess, fetchPsyTestReport
} from './psyTesting.actions';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class PsyTestingEffects {
  constructor(private actions$: Actions, private psyTestingService: PsyTestingService) {}

  generatePsyTest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(generatePsyTest),
      switchMap(({ userId, testTypeId }) =>
        this.psyTestingService.generatePsyTest(userId, testTypeId).pipe(
          map((response) => {
            if (!response || !response.data) {
              throw new Error('Invalid psy test response');
            }
            return generatePsyTestSuccess({ result: response.data });
          }),
          catchError((error) => of(generatePsyTestFailure({ error })))
        )
      )
    )
  );

  savePsyTestAnswers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(savePsyTestAnswers),
      switchMap(({ code, answers }) =>
        this.psyTestingService.savePsyTestAnswers(code, answers).pipe(
          map((response) => {
            if (!response || !response.data) {
              throw new Error('Failed to save answers: ' + response.message);
            }
            return savePsyTestAnswersSuccess({ result: response.data });
          }),
          catchError((error) => {
            // Extract the error message from the response
            const errorMessage = error.error?.message || 'An unknown error occurred.';
            return of(savePsyTestAnswersFailure({ error: errorMessage }));
          })

        )
      )
    )
  );

  fetchPsyTestReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchPsyTestReport),
      switchMap(({ code }) =>
        this.psyTestingService.fetchPsyTestReport(code).pipe(
          map((response) => {
            return fetchPsyTestReportSuccess({ report: response.data });
          }),
          catchError((error) => of(fetchPsyTestReportFailure({ error })))
        )
      )
    )
  );
}
